import React from "react";
import Task from "./Task";

const Tasks = () => {
  return (
    <div class="lws-task-list">
      <Task />
    </div>
  );
};

export default Tasks;
